import { computed, makeObservable } from 'mobx';
import { InputGroupChangeTracker } from '../../change_trackers';
import type InputBaseModel from '../inputs/InputBaseModel';
import type { ComparisonInputGroup } from './ComparisonNodeBaseModel';

export default class ComparisonInputGroupModel implements ComparisonInputGroup {
    private readonly tracker = new InputGroupChangeTracker();

    constructor(
        readonly id: string,
        readonly inputIds: string[],
        readonly getNewInputById: (inputId: string) => InputBaseModel | undefined,
        readonly getPreviousInputById: (inputId: string) => InputBaseModel | undefined
    ) {
        inputIds.forEach(inputId => {
            this.tracker.createInputChangeTracker(inputId, getNewInputById(inputId), getPreviousInputById(inputId));
        });

        makeObservable(this, {
            changes: computed
        });
    }

    get panelId() {
        return this.id;
    }

    get changes() {
        return this.tracker.aggregatedChanges;
    }

    dispose() {
        this.tracker.clearInputChangeTrackers();
    }
}
